import { computed } from "vue"
import { useRoute } from "vue-router"

export default function useRouteParams() {
  const route = useRoute()

  const id = computed(() => {
    const { id } = route.params
    return parseInt(
      Array.isArray(id) ? id[0] : id
    )
  })

  return { id }
}